module.exports = __webpack_public_path__ + "img/isocks.5cbe88bd.jpg";